import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
// import { Picker,List} from 'antd-mobile/lib';
import arrayTreeFilter from 'array-tree-filter';
import Util from '../../../util'
import {protocolCode ,bankCode} from '../../../BankCode'
import NavigatorMain from '../../NavigatorMain';
import { getInvestmentDetial } from '../../../action/myAssets/InvestPlanAction.js';
import PayWarmTips from './PayWarmTips';
import './Pay.css'
import { Toast } from 'antd-mobile/lib';
import { getCamcBankCardList,getMoneyChange,validateHqtPay,syncCwimToCamcNew,hasOtsRiskRearing, getTradeInfo,syncCwimRiskToCamcAndStopOutOfRiskBuyPlan} from '../../../action/productAction';
// import { traceSave } from '../../../action/riskInPayAction';
import HqtCard from './HqtCard'
import { myPaymentText } from '../../../action/publicAction';
import ModalList from '../../Modal/ModalList';
import { goPubQuestionnaires } from '../../../getPay'

class RechargeHqt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text:'',
      btnFlag:false,
      pwdFlag:false,
      keyPasswordVal:'',
      agreeIndex:0,
      setModalShow: false,
      rateAndFeeDate:{code:'',message:'',content:{fee:'--',feeBefore:'--',rate:'--',rate4:'--',rateBefore:'--'}},
      payInfoData:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[],currentNav:'',currentNavDate:'',fundCode:'',fundName:'',minAmount:''}},
      showRiskModal: false,
      isSignOnekeyFlag: false //直销卡签约弹窗
    };
  }
  componentWillMount(){
    document.title = "存入活期通"
    if(window.sessionStorage.getItem("hqtTipShow") != "false") {
      this.setState({
        setModalShow: true
      });
    };
    this.fetch();
  }
  onChangeText(text){
    let { 
      dispatch, 
      payInfoData
    } = this.props;
    let { fundCode, businessType, productType } = this.props.location.state;
    let flag=Util.regular1.test(text)
    this.setState({text});
    if (!flag) {
      return;
    }
    if (payInfoData.content.currentAccountList.length==0) {
      return;
    } 
    let item=payInfoData.content.currentAccountList[payInfoData.currentIndex];
    console.log(this.props.location,"this.porps.location")
    let data={
      currentAccountId:item.paymentAccountId,
      businessType:businessType,
      fundCode:fundCode,
      applicationAmount:text,
      payBuyHqt:true,
    }
    this.getMoneyChange(data)
  }
  getMoneyChange(data){
    getMoneyChange(data).then(e=>{
      this.setState({
        rateAndFeeDate:e
      })
    }).catch(err=>{
      
    })
  }
  next(){
    const { 
      dispatch,payInfoData
    }=this.props;
    let {text,agreeIndex,currentType,currentIndex}=this.state;
    if (agreeIndex==0) {
      let toast = Toast.show( '请同意特别提示内容', 2 );
      return;
    }
    if (!Util.regular1.test(this.state.text)) {
      let toast = Toast.show( '请输入正确格式的金额', 2 );
      return;
    }

    // let item=payInfoData.content.currentAccountList[payInfoData.currentIndex];
    // if (item.tradeMaxAmountTips.split('|')[0]-0<text) {
    //   Toast.info(  item.tradeMaxAmountTips.split('|')[1], 2 );
    //   return ;
    // } 
    let item=payInfoData.content.currentAccountList[payInfoData.currentIndex];

    console.log(currentIndex,"currentIndexcurrentIndexcurrentIndex")
    if (item.tradeMaxAmountTips.split('|')[0]-0<text) {
      let toast = Toast.show( item.tradeMaxAmountTips.split('|')[1], 2 );
      return ;
    }
    let cardSelect = payInfoData.content.currentAccountList[payInfoData.currentIndex];
    if(cardSelect.bankAccountShowNo2){
      this.setState({
        alertFlag:true,
        alertContent:`由于您在华夏基金的${item.bankName}（*${item.bankAccountShowNo.slice(-4)}）与华夏财富的${item.bankName}（*${item.bankAccountShowNo2.slice(-4)}）信息不一致，该渠道活期通份额暂不可用。如需银行卡信息变更，请您分别在华夏基金官网和华夏财富官网进行变更。如有疑问，请咨询客服热线400-817-5666。`
      })
      return
    }else if(cardSelect.trustChannelDisplayName == "招商银行在线支付") {
      if(cardSelect.ywt == false) {
        this.setState({
          alertFlag:true,
          alertContent:"您的银行卡未签约，请登录华夏基金官网【银行卡管理-代扣签约】进行签约升级或咨询投资顾问。客服电话：400-817-5666"
        })
        return
      }else if(cardSelect.ywt == null) {
        if(cardSelect.enableCMBTrustChannel === false){
          this.setState({
            alertFlag:true,
            alertContent:"为确保资金同卡进出的原则，请补充该招商银行卡信息，该渠道活期通份额方可在华夏财富使用。您可以直接登录华夏财富官网个人中心提交银行卡信息，或致电客服热线400-817-5666进行办理。"
          })
          return
        }
      }
    }
    console.log(payInfoData,"payInfoDatapayInfoDatapayInfoData",currentIndex)
    //直销卡没签约弹窗
    if(!(cardSelect.signOnekey === true || cardSelect.signTripleAgreement === true)) {
      this.setState({
        isSignOnekeyFlag: true
      });
      return;
    }
    this.openPwd()
  }
  fetch(){
    let { 
      fundCode, 
      businessType,
      productType,
      bankAccountShowNo
    } = this.props.location.state
    let {dispatch,payInfoData,hqtCardList}=this.props;
    if (payInfoData.currentType==4) {
      dispatch(getCamcBankCardList(fundCode,businessType,this.props.bankAccountShowNo,(result,i,type)=>{
        let AccountList = result.content && result.content.currentAccountList;
        for(let i =0; i<result.content.currentAccountList.length; i++ ){
        for(let j = 0; j<hqtCardList.length; j++){
          if(hqtCardList[j].enableCMBTrustChannel === "0" && result.content.currentAccountList[i].bankCode === hqtCardList[j].bankCode ){
            result.content.currentAccountList[i].enableCMBTrustChannel = hqtCardList[j].enableCMBTrustChannel;
            result.content.currentAccountList[i].bankAccountShowNo2 = hqtCardList[j].bankAccountShowNo2
          }else {
            if(hqtCardList[j].trustChannelDisplayName === "招商银行在线支付" && result.content.currentAccountList[i].bankCode === hqtCardList[j].bankCode) {
              if(hqtCardList[j].ywt == true) {

              }else if(hqtCardList[j].ywt == false) {
                result.content.currentAccountList[i].enableCMBTrustChannel = hqtCardList[j].enableCMBTrustChannel;
                result.content.currentAccountList[i].trustChannelDisplayName = hqtCardList[j].trustChannelDisplayName;
              }else {
                if(hqtCardList[j].enableCMBTrustChannel === false) {
                  result.content.currentAccountList[i].enableCMBTrustChannel = hqtCardList[j].enableCMBTrustChannel;
                  result.content.currentAccountList[i].trustChannelDisplayName = hqtCardList[j].trustChannelDisplayName;
                }
              }
            }
          }
        }
      }
        dispatch({
          type:"HQT_PAY_INFO",
          text:result
        });

      }))
    }
    
  }
  onChangePwd(val){
    this.setState({
      keyPasswordVal:val
    })
  }
  isAgreeClick(){
    let { agreeIndex } =this.state;
    if (agreeIndex===0) {
      this.setState({
        agreeIndex:1
      })
    } else {
      this.setState({
        agreeIndex:0,
      })
    }
  }
  keyOk(res){
    const { 
      payInfoData,
      dispatch,
    }=this.props;
    let {
      fundCode, 
      businessType,
      fundName
    } = this.props.location.state;
    let _this=this;
    let {text,keyPasswordVal}=this.state;
    const pushResult = (i,result) => {
      Toast.hide();
      if (i==1) {
        // dispatch(traceSave(this.props.location.state.traceSaveObj));
        // dispatch(traceSave({action: 'SPECIAL_TIP', message:'已阅读充值活期通特别提示' }));
        // dispatch(traceSave({action: 'READ_TIPS', message: this.props.location.state.fundRisk?'充值高于自身风险基金：'+payInfoData.content.fundName:'充值'+payInfoData.content.fundName }))
        // dispatch(traceSave({action: 'BUY_WARN_AGAIN', message: this.props.location.state.fundRisk?'充值高于自身风险基金：'+payInfoData.content.fundName:'充值'+payInfoData.content.fundName }))
        hashHistory.push({
          pathname:'/Success',
          state: {
            title:'充值结果',
            content:'申请已受理',
            dataSouse:[['申请编号',result.content],['产品名称','活期通'],['投资金额',Util.parsePrice(text)+'元']],
            souseVal:['返回我的智投'],
          }
        });
      } else if (i==3) {
          hashHistory.push({
            pathname:'/ErrorResult',
            state: {
              title:'充值失败',
              content:'充值失败',
              content2:result,
              dataSouse:[],
              souseVal:['返回华夏智投','联系客服'],
            }
          });
      }
    }  
    let item=payInfoData.content.currentAccountList[payInfoData.currentIndex];
    let data={
      amount:text-0,
      businessType:businessType,
      fundCode:fundCode,
      clientIp: '127.0.0.1',
      password:Util.encrypt(keyPasswordVal),
      paymentAccountId:item.paymentAccountId,
    }

    const findHqtExist = this.props.findHqtExist;
    let params = {
      otsTradeAccountNo:findHqtExist.tradeAccountNo,
      raiseMethod:"9"
    }
    if(res == "1") {
      try{
        dispatch(syncCwimToCamcNew({}, (_flag) => {
          if(_flag) {
            dispatch(validateHqtPay(data,pushResult));
          }else {
            this.riskShowFun();
          }
        }))
      }catch(err){
          Toast.hide();
      }
    }else if(res == "2") {
      try{
        dispatch(validateHqtPay(data,pushResult));
      }catch(err){
          Toast.hide();
      }
    }else {
      try{
          dispatch(hasOtsRiskRearing(params,(c1,c2,z1)=>{
            console.log(c1,c2,z1,"是否同步问卷")
            if(z1){
                dispatch(validateHqtPay(data,pushResult));
            }else{
              if(c1 === c2){
                  console.log(c1,c2,z1,"c1 === c2同步问卷")
                  dispatch(syncCwimToCamcNew({}, (_flag) => {
                    if(_flag) {
                      dispatch(validateHqtPay(data,pushResult));
                    }else {
                      this.riskShowFun();
                    }
                  }))
              }else{
                console.log(c1,c2,z1,"c1 === c2同步问卷")
                goPubQuestionnaires(hashHistory, window.history.length, ()=>{
                  dispatch(syncCwimToCamcNew({}, (_flag) => {
                    if(_flag) {
                      dispatch(validateHqtPay(data,pushResult));
                    }else {
                      this.riskShowFun();
                    }
                  }))
                })
              }
            }
          }))
      }catch(err){
          Toast.hide();
          console.log(err,'同步问卷失败')
      }
    }

    // dispatch(validateHqtPay(data,pushResult))
    
  }
  goRember = () => {
    hashHistory.push({
      pathname: "/BankCardList", 
      state: {
        title: '重置交易密码'
      }
    });
  }
  goSetOk = () => {
    this.setState({
      setModalShow: false
    });
    window.sessionStorage.setItem('hqtTipShow',false);
  }
  currencyFundChange(i,type){
    console.log(i,type)
    this.setState({
      currentIndex:i,
      currentType:type
    })
    let {payInfoData}=this.props;
    var item=payInfoData.content.currentAccountList[i];
    var data={
      currentAccountId:item.paymentAccountId,
      businessType:this.props.businessType,
      fundCode:payInfoData.content.fundCode,
      applicationAmount:this.state.text,
      payBuyHqt:true,
    }
    this.getMoneyChange(data)
  }
  openPwd(){
    this.setState({
      pwdFlag:true
    })
  }
  closeMoadl = ()=>{
    this.setState({
      alertFlag:false
    })
  }
  goBack = () => {
    hashHistory.goBack();
    if(this.props.location.state.refresh) {
      setTimeout(() => {
        this.props.dispatch(getTradeInfo(this.props.location.state._fundCode,'T522',this.props.location.state.productType,(result,i,type)=>{
          Object.assign(result,{currentType:type},{currentIndex:i})
          this.props.dispatch({
            type:"SUPER_FUND_PAY_INFO",
            text:result
          });
        }))
      })
    }
  }
  resetRiskFun = () => {
    this.setState({
      showRiskModal: false
    });
    goPubQuestionnaires(hashHistory, window.history.length, ()=>{
      this.keyOk("1");
    });
    return;
  }
  sameDataFun = () => {
    this.setState({
      showRiskModal: false
    });
    this.props.dispatch(syncCwimRiskToCamcAndStopOutOfRiskBuyPlan({}, () => {
      this.keyOk("2");
    }));
    return;
  }
  riskShowFun = () => {
    this.setState({
      showRiskModal: true
    });
  }
  isSignOnekeyModalOk = () => {
    this.setState({
      isSignOnekeyFlag: false
    });
  }
  render(){
    const img_arr = [require('../../../img/square.png'),require('../../../img/protocol_selected.png')]
    let {fundName,fundCode,fundType,wanfenshouyi,currentNavDate,currentNav,businessType,fundRisk}=this.props.location.state;
    let {payInfoData}=this.props;
    Object.assign(payInfoData,{currentType:2},{currentIndex:this.props.location.state.currentIndex?this.props.location.state.currentIndex:0})
    console.log(payInfoData,"******payInfoDatapayInfoDatapayInfoData",this.props)
    let {rateAndFeeDate, currentType,currentIndex}=this.state
    return (
        <div className="container" >
          <NavigatorMain>
            <div className="header black">
              <div onClick={this.goBack}><span className="headerLeftBtn"></span></div>
              <div>存入活期通</div>
              <div></div>
            </div>
          </NavigatorMain>
          <div className='content'>
            <div className='fixed-invest-header'>
              <div className='fixed-invest-header-top'>
                <p className='fixed-invest-header-top-name'>{"活期通(" + Util.formatStr(payInfoData.content.fundName) + ")"}</p>
                <p className='fixed-invest-header-top-type'>{businessType=='T022'?'申购':businessType=='T020'?'认购':''}</p>
              </div>
              <div className='fixed-invest-header-bottom'>
              {
                businessType!='T022'?`最新净值 ：1.000元`:
                `万份收益:${Util.fomatFloat(Util.formatStr(payInfoData.content.currentNav),4)}元(${Util.formatStr(payInfoData.content.currentNavDate)})`
              }
              </div>
            </div>
            <div className='share'>
              <div className='shareTitle'>
                请选择支付方式
              </div>
            </div>
            <HqtCard type='hqt' actionType='HQT' fetch={ this.fetch.bind(this) } />
            <div className='input'>
              <p>投资金额</p>
              <input autocomplete="off" onChange={(e)=>this.onChangeText(e.target.value)} type="text"  placeholder={'最低投资金额'+Util.parsePrice(payInfoData.content.minAmount)+'元'} />
            </div>
            <div className='pay-agree' >
              <img src={img_arr[this.state.agreeIndex]}  className='imgBtn' onClick={()=>this.isAgreeClick()}/>
              <p>已阅读特别提示内容</p>
            </div>
            <div className='pay-fee'>
              <p >费率：</p><p><span className='red-t'>{Util.formatStr(rateAndFeeDate.content.rate)=='0.00'||Util.formatStr(rateAndFeeDate.content.rate)=='0.00%'||Util.formatStr(rateAndFeeDate.content.rate)=='0%'?'0%':Util.formatStr(rateAndFeeDate.content.rate)}</span></p>
              <p >预计费用：</p><p><span className='red-t'>{Util.formatStr(rateAndFeeDate.content.fee)=='0.00'||Util.formatStr(rateAndFeeDate.content.fee)=='0.00%'||Util.formatStr(rateAndFeeDate.content.fee)=='0%'?'0元':Util.formatStr(rateAndFeeDate.content.fee)}</span></p>
            </div>
            {
              Util.regular1.test(this.state.text)&&this.state.agreeIndex==1?<div onClick={()=>this.next()} className='btn'>确认买入</div>:
              <div  className='btn btn-gray'>确认买入</div>
            }
            <div style={{marginTop:40}}>
              <PayWarmTips hqt={true} fundLimit={this.props.location.state.fundCode}/>
            </div>
          </div>
          {
            this.state.pwdFlag?
            <div  style={{position:'fixed',top:0,width:'100%',height:'100%',background:'rgba(52,52,52,0.4)'}}>
              <div style={{position:'fixed',bottom:0,width:'100%',height:'70%',background:'#fff'}}>
                <div style={{position:'relative',height:'45px',lineHeight:'45px',textAlign:'center',borderBottom:'0.005rem solid rgb(224,227,279)',fontSize:'0.3rem'}}>
                  交易密码
                  <img src={require('../../../img/close.png')}  style={{position:'absolute',left:0,width:'0.88rem',height:'0.88rem'}} onClick={()=>{this.setState({pwdFlag:false})}}/>
                  <span  style={{position:'absolute',top:0,right:0,width:'45px',fontSize:'13px'}} className='red-t' onClick={()=>{this.keyOk()}}> 确认</span>
                </div>
                <div style={{padding:'0.3rem 0.3rem 0rem 0.3rem',fontSize:'13px'}}>
                  {`温馨提示：${fundRisk?'温馨提示：本人已完成风险测评问卷，并对申请购买的基金产品风险等级高于本人的风险承受能力情况已知晓，并已充分了解该基金产品的风险特征和可能的不利后果。本人仍坚持自愿投资该基金产品，并自愿承担由此可能产生的一切不利后果和损失。基金募集机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该基金产品或服务的行为。':'请充分了解投资风险，并确定符合您的投资目标。'}`}
                </div>
                <div style={{height:'45px',padding:'13px'}}>
                  <input autocomplete="off" onChange={(e)=>this.onChangePwd(e.target.value)} autofocus="autofocus" style={{height:'45px',width:'100%',fontSize:'0.3rem',border:'1px solid #afafaf',borderRadius:'0.1rem'}} type="password"  placeholder=""/>
                </div>
                <div style={{paddingTop: 40, paddingRight: 10, textAlign: "right"}}>
                  <span onClick={this.goRember} style={{fontSize:12,color:'#FE492E',textAlign:'right'}}>忘记密码？</span>
                </div>
              </div>
            </div>
            :null
          }
          <ModalList contentSec='如需办理活期通赎回、交易查询等业务，请登录华夏基金管家或华夏基金官网' flag={this.state.setModalShow} btnRight={"确认"} btnRightFun={this.goSetOk} content={`尊敬的客户，活期通是由华夏基金提供的理财产品，通过华夏基金及华夏财富均可办理活期通申购业务，持有的活期通余额可以用于申购华夏财富代销的产品。`} title={"特别提示"} />
          
          <ModalList flag={this.state.alertFlag} btnRight={"确认"} btnRightFun={this.closeMoadl} content={this.state.alertContent} title={"温馨提示"} />
          {
            this.state.showRiskModal ?
            <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
                <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>温馨提示</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>活期通、闪购相关服务由华夏基金提供，根据华夏基金的评分标准，您的风险承受能力为：C1保守型。</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>根据《证券期货投资者适当性管理办法》的规定，您适合交易风险等级为R1的产品。<span style={{fontSize: 15, color: "#333", lineHeight: "20px", fontWeight: "bold"}}>您如果确定认同此风险等级评定，为了降低您的风险，我们将终止您在华夏基金已经签约的R1产品以外的计划类交易，包括定投、智能认购、定期转换等。</span></p>
                </div>
                <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                  <div onClick={this.resetRiskFun} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#F92C3D"}}>重新测评</p>
                  </div>
                  <div onClick={this.sameDataFun} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#fff"}}>确认</p>
                  </div>
                </div>
              </div>
            </div>
            :
            null
          }         
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  console.log(ownProps);
  return {
    pageFlag:state.pageFlag,
    keyPasswordVal:state.keyPasswordVal,
    hqtCardList:state.hqtCardList,
    payInfoData:state.hqtPayInfo,
    findHqtExist:state.findHqtExist,
  }
}
export default connect(mapStateToProps)(RechargeHqt);



// WEBPACK FOOTER //
// ./src/components/myAssets/payment/RechargeHqt.js